//you probably need to use [modal,setModal] to open and close the modal in whatever file you use it on

import { JSX } from "react";
import useSwipeToDismiss from "../hooks/useSwipeToDismiss";

interface ModalProps {
  showModal: boolean;
  onClose?: () => void;
  className?: string;
  mainComponent?: JSX.Element;
  children?: React.ReactNode;
  mobileBottomSheet?: boolean;
}

const ModalTemplate = ({
  showModal,
  onClose,
  className,
  mainComponent,
  children,
  mobileBottomSheet = false,
}: ModalProps) => {
  const { sheetRef, swipeHandlers } = useSwipeToDismiss(
    onClose,
    mobileBottomSheet && showModal
  );

  return (
    <div
      className={`fixed inset-0 z-[120] flex justify-center transition-opacity duration-300 ${
        mobileBottomSheet ? "items-end tablet:items-center" : "items-center"
      } ${showModal ? "visible bg-black/40 opacity-100" : "invisible opacity-0"}`}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        ref={sheetRef}
        {...swipeHandlers}
        className={`z-50 flex flex-col items-center justify-center ${
          mobileBottomSheet
            ? "max-h-[calc(100dvh-12px)] w-full overscroll-y-contain overflow-y-auto rounded-t-[28px] bg-white px-0 pb-[env(safe-area-inset-bottom)] pt-3 tablet:w-auto tablet:rounded-3xl tablet:bg-grey-100 tablet:px-[90px] tablet:py-16"
            : "rounded-3xl border-grey-400 bg-grey-100 px-[90px] py-16"
        } ${className ?? ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {mobileBottomSheet && (
          <span
            className="mb-1 h-1 w-10 shrink-0 rounded-full bg-gray-300 tablet:hidden"
            aria-hidden="true"
          />
        )}
        {mainComponent}
        {children}
      </div>
    </div>
  );
};

export default ModalTemplate;
